import { formatDate } from "../../../common/functions";

const na = (v) => (v ? v : "N/A");
const fmtDate = (v) =>
  !v || v === "pending" || v === "N-A" ? v || "N/A" : formatDate(v);

/**
 * Column config for the Quality Reports table. Each entry drives a DataGrid
 * column with an embedded per-column server-side search control (see
 * createSearchColumns / ColumnHeaderSearch). `search` is the control kind; each
 * `field` must match a key the backend whitelists in QR_SEARCHABLE_FIELDS
 * (qualityReportListShared).
 *
 * Rows come from two sources (current + historical). Where the two store a value
 * under different names, the `valueGetter` coalesces them for display so the
 * cell matches what search finds; columns with no historical equivalent simply
 * show "N/A" for historical rows.
 */
export const allQualityReportsColumnConfig = [
  {
    field: "HODDepartment",
    minWidth: 200,
    search: "text",
    csvFormat: "naText",
    valueGetter: (p) => na(p.row.HODDepartment || p.row.requestingDepartment),
  },
  {
    field: "executiveChefEmail",
    minWidth: 220,
    search: "text",
    csvFormat: "naText",
    valueGetter: (p) => na(p.row.executiveChefEmail),
  },
  {
    field: "requesterEmail",
    headerName: "Chef Email / Requestor Name",
    minWidth: 240,
    search: "text",
    csvFormat: "naText",
    valueGetter: (p) => na(p.row.requesterEmail || p.row.chefEmail),
  },
  {
    field: "itemERPCode",
    minWidth: 160,
    search: "text",
    csvFormat: "naText",
    valueGetter: (p) => na(p.row.itemERPCode),
  },
  {
    field: "itemDescription",
    minWidth: 220,
    search: "text",
    csvFormat: "naText",
    valueGetter: (p) => na(p.row.itemDescription),
  },
  {
    field: "specification",
    minWidth: 200,
    search: "text",
    csvFormat: "naText",
    valueGetter: (p) => na(p.row.specification),
  },
  {
    field: "preferredUnitOfMeasure",
    minWidth: 200,
    search: "text",
    csvFormat: "naText",
    valueGetter: (p) => na(p.row.preferredUnitOfMeasure || p.row.packing),
  },
  {
    field: "name",
    headerName: "Supplier Name",
    minWidth: 240,
    search: "text",
    csvFormat: "naText",
    valueGetter: (p) => na(p.row.name),
  },
  {
    field: "email",
    headerName: "Supplier Email",
    minWidth: 200,
    search: "text",
    csvFormat: "naText",
    valueGetter: (p) => na(p.row.email),
  },
  {
    field: "requestDate",
    minWidth: 180,
    search: "date",
    type: "date",
    csvFormat: "qrDate",
    valueFormatter: (p) => fmtDate(p.value),
  },
  {
    field: "receiptDate",
    minWidth: 180,
    search: "date",
    type: "date",
    csvFormat: "qrDate",
    valueGetter: (p) => p.row.receiptDate || p.row.sampleSubmitDate,
    valueFormatter: (p) => fmtDate(p.value),
  },
  {
    field: "approvalDate",
    minWidth: 180,
    search: "date",
    type: "date",
    csvFormat: "qrDate",
    valueFormatter: (p) => fmtDate(p.value),
  },
  {
    field: "qualityReportsID",
    minWidth: 240,
    search: "text",
    csvFormat: "naText",
    valueGetter: (p) => na(p.row.qualityReportsID),
  },
  {
    field: "sampleRequestID",
    minWidth: 240,
    search: "text",
    csvFormat: "naText",
    valueGetter: (p) => na(p.row.sampleRequestID),
  },
  {
    field: "sampleItemID",
    minWidth: 240,
    search: "text",
    csvFormat: "naText",
    valueGetter: (p) => na(p.row.sampleItemID),
  },
];
